import React from "react";
import styled from "styled-components";
import { style } from "./style";

const spaceVars = style.vars.space;

type Space = keyof typeof spaceVars;

type Props = {
  space: Space | string;
  as?: keyof JSX.IntrinsicElements;
};

const getSpace = (size: Space | string) => {
  if (typeof size === "string") {
    return size;
  }

  return spaceVars[size];
};

type ContainerProps = {
  $space: string;
};

const Container = styled.div<ContainerProps>`
  display: block;
  ${(props) => ({ marginBottom: props.$space })}
`;

export const Spacer = React.forwardRef<HTMLElement, Props>((props, ref) => {
  /**
   * Do not use object spread `{ ...props }` here to avoid
   * injecting additional properties into the container.
   */
  return <Container ref={ref} as={props.as} $space={getSpace(props.space)} />;
});

Spacer.displayName = "Spacer";
